var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-login"},[_c('div',{staticClass:"login-content"},[(
        ['login', 'register', 'roblox login', 'roblox cookie'].includes(
          _vm.modalTab
        ) === true
      )?_c('div',{staticClass:"content-auth"},[(['roblox login', 'roblox cookie'].includes(_vm.modalTab) === true)?_c('LoginRoblox',{attrs:{"tab":_vm.modalTab}}):_c('LoginCredentials',{attrs:{"tab":_vm.modalTab}})],1):_c('LoginForgot')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }